(function ($, app) {
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function removeUrlParameter(url, name) {
        var urlParts = url.split('?');
        if (urlParts.length >= 2) {
            var prefix = encodeURIComponent(name) + '=';
            var params = urlParts[1].split(/[&;]/g);
            for (var i = params.length; i-- > 0;) {
                if (params[i].lastIndexOf(prefix, 0) !== -1) {
                    params.splice(i, 1);
                }
            }
            return urlParts[0] + (params.length > 0 ? '?' + params.join('&') : '');
        } else {
            return url;
        }
    }

    var ready = new $.Deferred();

    app.settings.ready(function () {
        $(function () {
            ready.resolve();
        });
    });

    ready.done(function() {
        var webPushQuery = getUrlParameter('wp');
        var accountId = window.GlobalSettings.AccountId;
        var isGuestCheckoutEnabled = window.CheckoutSettings.getBasketSettings().UseGuestCheckoutTwoSteps || window.CheckoutSettings.getBasketSettings().UseGuestCheckout;
        var isUnauthorized = app.cookie.get('us') === null || app.cookie.get('us') === 'unl';

        if (webPushQuery !== '' && (isGuestCheckoutEnabled || (!isGuestCheckoutEnabled && !isUnauthorized))) {
            var url = '/api/shop/myaccount/v1/accounts/' + accountId + '/my-account/notifications/webpush/feedback';
            var payload = JSON.stringify({
                data: webPushQuery
            });
            $.ajax(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: payload,
                success: function (data) {
                    if (window.history.replaceState) {
                        window.history.replaceState({}, document.title, removeUrlParameter(location.href, 'wp'));
                    } else {
                        location.replace(removeUrlParameter(location.href, 'wp'));
                    }
                }
            });
        }
    });

})(jQuery, app);